<template>
  <div class="exporting">
    <el-dropdown>
      <el-button type="primary">
        <img src="../assets/images/icon01.png" style="width:16px; height:16px;" />
        下载
      </el-button>
      <template #dropdown>
        <el-dropdown-menu>
          <el-dropdown-item @click="exportExcel">下载excel</el-dropdown-item>
          <el-dropdown-item @click="exportImg">下载png</el-dropdown-item>
        </el-dropdown-menu>
      </template>
    </el-dropdown>

    <!-- <a title="导出excel" @click="exportExcel">
      <img src="../assets/images/exp_excel.png" />
    </a>
    <a title="保存图片" @click="exportImg">
      <img src="../assets/images/save_pic.png" />
    </a> -->
  </div>
</template>

<script setup>
  import { ElDropdown, ElButton, ElDropdownMenu, ElDropdownItem, ElIcon } from 'element-plus';
  const emits = defineEmits();

  const exportImg = () => {
    emits('exportImg');
  };
  const exportExcel = () => {
    emits('exportExcel');
  };
</script>

<style lang="less" scoped>
  .exporting {
    display: flex;
    a {
      padding-top: 4px;
      cursor: pointer;
      &:first-child {
        margin-right: 5px;
      }
    }

    img {
      display: block;
      height: 25px;
    }

    :deep(.el-button--primary) {
      --el-button-bg-color: var(--light-color);
      --el-button-border-color: var(--light-color);

      &.el-button {
        height: 36px;
      }
    }
  }
</style>